import { expVal } from '@atlassian/jira-feature-experiments';

const TimelineStickyAssigneeStatusColumnRelayProvider = {
	get(): boolean {
		return expVal('jira_timeline_sticky_assignee_status_columns_exp', 'isEnabled', false);
	},
};

export default TimelineStickyAssigneeStatusColumnRelayProvider;
